module.exports = __webpack_public_path__ + "static/media/bg_icon_2.1d6602f4.svg";